// État des disponibilités

export const AVAILABILITY_STATE_VALUE_AVAILABLE = "av";
export const AVAILABILITY_STATE_VALUE_UNAVAILABLE = "un";
export const AVAILABILITY_STATE_VALUE_CLOSED = "cl";
export const AVAILABILITY_STATE_VALUE_BUSY = "bo";

export const AVAILABILITY_STATES = {
  [AVAILABILITY_STATE_VALUE_AVAILABLE]: {
    key: AVAILABILITY_STATE_VALUE_AVAILABLE,
  },
  [AVAILABILITY_STATE_VALUE_UNAVAILABLE]: {
    key: AVAILABILITY_STATE_VALUE_UNAVAILABLE,
  },
  [AVAILABILITY_STATE_VALUE_CLOSED]: {
    key: AVAILABILITY_STATE_VALUE_CLOSED,
  },
  [AVAILABILITY_STATE_VALUE_BUSY]: {
    key: AVAILABILITY_STATE_VALUE_BUSY,
  },
};
